<template>
    <div class="numbox block-box" v-if="configData">
        <div class="block-item">
            <div class="label" :span="4">
                {{configData.title ||'商品数量'}}
            </div>
            <el-input-number v-model="configData.val" :min="configData.min > 0 ? configData.min : 0" :precision="0"></el-input-number>
        </div>
    </div>
</template>

<script>
    export default {
        name: "input",
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
    }
</script>

<style scoped lang="less">
</style>
